import { Base64Decryption, Base64Encryption } from './encryption';
export interface PermissionItem {
    value: string;
    // 标签
    label: string;
    // 资源码 与后台对应
    source: number;
    // 扩展
    level?: number;
    path?: string;
    componentPath?: string;
    icon?: string;
    show?: boolean;
    hidden?: boolean;
    children?: Array<Partial<PermissionItem>>
}

export const data: { [key: string]: PermissionItem } = {
    RT1000: {
        value: "0,0",
        source: 1000,
        label: "开发测试01",
        icon: 'icon-home',
        level: 1,
        path: '/dev'
    },
    RT2000: {
        value: "0,1",
        source: 2000,
        label: "开发测试02",
        icon: 'icon-jiaoyi',
        level: 1,
        path: '/dev'
    }
}

const isDevMode = (): boolean => false;
class Proof {

    // 权限 code 
    // 形式："1,0" 1-index 0-pos
    // pos 表示 32 位二进制数中 1 的位置
    // index 表示权限空间，用于突破 JavaScript 数字位数的限制
    // 目前采用原生js技术,每个空间下最多32位
    // 幂乘优化 Math.pow(2,3) 等同于 2**3 结果 8
    private _userCode: string = '';
    private get userCode(): string {
        return this._userCode;
    }
    private set userCode(value: string) {
        this._userCode = value;
    }

    constructor() {
        if (isDevMode()) {
            setTimeout(() => {
                console.group('安全码检测中.....');
                const values = this.Permissions.map((t: PermissionItem) => t.value);
                const sources = this.Permissions.map((t: PermissionItem) => t.source);
                const warningStyle = `color:red;font-size:18px;font-weight:800;`;
                const repearValues = values.filter(i => values.indexOf(i) !== values.lastIndexOf(i));
                if (repearValues && repearValues.length) {
                    console.log(`%c%s`, warningStyle, `权限码重复`);
                    console.log(repearValues);
                }

                const repearSources = sources.filter(i => sources.indexOf(i) !== sources.lastIndexOf(i));
                if (repearSources && repearSources.length) {
                    console.log(`%c%s`, warningStyle, `资源码重复`);
                    console.log(repearSources);
                }

                if (repearValues?.length == 0 && repearSources?.length == 0) {
                    console.log(`%c%s`, `color:green;`, `安全码校验通过`);
                }

                console.log('校验结束')
                console.groupEnd();
            }, 200);
        }
    }

    // 全系统内所有权限信息
    get Permissions() {
        return [
            ...Object.values(data)
        ]
    }

    // 初始化用户权限码
    public initUserCode(sourceCode: Array<number>): string {
        this.userCode = '';
        Object.values(this.Permissions).forEach((item: PermissionItem) => {
            if (sourceCode.includes(item.source)) this.addPermission(item);
        });

        return this.userCode;
    }

    // 权限校验
    public checkPermission(permission: PermissionItem): boolean {

        // this.userCode = this.userCode || Base64Decryption('');
        return this.hasPermission(permission);
    }


    // 返回加密后权限信息
    public async getEncryptionCode(): Promise<string> {
        return new Promise((resolve) => {
            const encryptedCodes = Base64Encryption(this.userCode);

            resolve(encryptedCodes);
        })
    }

    public addPermission(permission: PermissionItem): void {
        const userPermission: Array<number> = this.userCode ? this.userCode.split(',').map(n => +n) : [];
        const [index, pos] = permission.value.split(',');
        const _index: number = parseInt(index);
        const _pos: number = parseInt(pos);

        userPermission[_index] = (userPermission[_index] || 0) | 2 ** _pos;

        this.userCode = userPermission.join(',');
    }

    public delPermission(permission: PermissionItem): void {

        const userPermission: Array<number> = this.userCode ? this.userCode.split(',').map(n => +n) : [];
        const [index, pos] = permission.value.split(',');
        const _index: number = parseInt(index);
        const _pos: number = parseInt(pos);

        userPermission[_index] = (userPermission[_index] || 0) & (~(2 ** _pos));

        this.userCode = userPermission.join(',');
    }

    public hasPermission(permission: PermissionItem): boolean {
        const userPermission: Array<number> = this.userCode ? this.userCode.split(',').map(n => +n) : [];
        const [index, pos] = permission.value.split(',');
        const _index: number = parseInt(index);
        const _pos: number = parseInt(pos);
        const permissionValue = 2 ** _pos;

        return (userPermission[_index] & permissionValue) === permissionValue;
    }

    // public allPermission(): Array<PermissionItem> {

    //     const results: Array<PermissionItem> = [];

    //     if (!this.userCode) return results;

    //     Object.values(this.Permissions).forEach((permission: PermissionItem) => {
    //         this.hasPermission(permission) && results.push(permission);
    //     });

    //     return results;
    // }

    // public allSourceCode(): Array<number> {

    //     const results: Array<number> = [];

    //     Object.values(this.Permissions).forEach((permission: PermissionItem) => {
    //         results.push(permission.source);
    //     });

    //     return results;
    // }

    // public listPermission(): Array<string> {

    //     const results: Array<string> = [];

    //     if (!this.userCode) return results;

    //     Object.values(this.Permissions).forEach((permission: PermissionItem) => {
    //         this.hasPermission(permission) && results.push(permission.label);
    //     });

    //     return results;
    // }

    // public valuePermission(): Array<string> {

    //     const results: Array<string> = [];

    //     if (!this.userCode) return results;

    //     Object.values(this.Permissions).forEach((permission: PermissionItem) => {
    //         this.hasPermission(permission) && results.push(permission.value);
    //     });

    //     return results;
    // }

    // public sourcePermission(): Array<number> {

    //     const results: Array<number> = [];

    //     if (!this.userCode) return results;

    //     Object.values(this.Permissions).forEach((permission: PermissionItem) => {
    //         this.hasPermission(permission) && results.push(permission.source);
    //     });

    //     return results;
    // }

    public clearPermission() {

        this.userCode = '';
    }
}

export default new Proof();